module.exports = __webpack_public_path__ + "media/images/application/law-c23b5051eb8d8c9169fd0c54fde243f3.jpg";